<script>
    export let style
</script>

<div class="component-card component-card-section" { style }>
    <slot />
</div>
